<template>
  <div style="padding: 0 15px">
    <!-- 工具栏 -->
    <div class="filter-container">
      <el-button class="filter-item" size="small" icon="el-icon-circle-plus-outline" type="primary" @click="yonghuquanxianbtn">添加用户</el-button>
      <el-button class="filter-item" size="small" icon="el-icon-delete" type="danger" @click="piliangshanchuquanxian">批量删除</el-button>
      <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width: 220px"></el-input>
      <el-button class="filter-item" type="primary" size="small" @click="chaxunbtn">查询</el-button>
    </div>

    <!-- table 列表-->
    <el-table class="grayTableTile" size="mini" v-loading="listLoading"  ref="multipleTable" :data="tableData" border style="width: 100%" @sort-change="handleAgeSortChange" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="username" label="账号" sortable='custom' min-width="100px"></el-table-column>
      <el-table-column prop="realname" label="用户名" sortable='custom' min-width="100px"></el-table-column>
      <el-table-column prop="email" label="邮箱" sortable='custom' min-width="130px"></el-table-column>
      <el-table-column prop="locked" label="状态" min-width="130px">
        <template slot-scope="scope">
          {{ scope.row.locked | lockedguolv }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="email" label="角色类型" sortable='custom'></el-table-column>  -->

      <el-table-column prop="addTime" label="创建时间" sortable='custom' min-width="100px"></el-table-column>
      <el-table-column prop="" label="操作" width="120">
        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-danger" :disabled="!scope.row.del" @click="quanxianshanchu(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="margin-top:0;" @pagination="getList" />

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { userdoRemoveRole, pageUsersByRoleId } from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
export default {
  components: { Pagination },
  data() {
    return {
      search: '',
      listLoading: false,
      originalCaseTable: [],// 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      userInfo: {}, // 详情

      multipleSelection: [], // 选中
    }
  },
  filters: {
    lockedguolv(value) {
      if (value == "0") {
        return "正常";
      } else if (value == "1") {
        return "离职锁定";
      } else if (value == "2") {
        return "待审核";
      } else if (value == "3") {
        return "正常";
      } else if (value == "4") {
        return "过期锁定";
      }
    },
  },

  methods: {

    init(row, list) {
      this.userInfo = row
      this.search = ''
      this.listLoading = false
      this.tableData = []
      this.total = 0
      this.listQuery = {
        pageNo: 1,
        pageSize: 10
      }
      this.multipleSelection = []
      this.getList();
    },
    getList() {
      var datas = {
        id: this.userInfo.id,//角色Id
        queryWord: this.search,//模糊词
        pageNo: this.listQuery.pageNo,//
        pageSize: this.listQuery.pageSize//
      }
      

      this.listLoading = true
      pageUsersByRoleId(datas).then(response => {
        if (response.code == 1) {
          this.tableData = response.data.result
          this.total = response.data.totalCount
          this.$refs.multipleTable.clearSelection();
        }
        this.listLoading = false
      })

    },
    chaxunbtn(){
      this.listQuery.pageNo = 1;
      this.getList();
    },

    // 排序
    handleAgeSortChange(e) {
      if (e.order) {
        const order = e.order == 'descending' ? false : true
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 添加到用户组
    yonghuquanxianbtn() {
      this.$emit('handleAddGroups')
    },

    // 批量删除
    piliangshanchuquanxian() {
      if (this.multipleSelection.length > 0) {
        const ids = []
        this.multipleSelection.forEach(m => {
          ids.push(m.id)
        });

        const data = {
          userId: ids,
          roleId: [this.userInfo.id]
        }
        this.handleDelete(data)
      } else {
        this.$message({
          message: "请先选择要删除的用户权限",
          type: "error"
        });
      }
    },

    // 单个删除
    quanxianshanchu(row) {
      const data = {
        userId: [row.id],
        roleId: [this.userInfo.id]
      }
      this.handleDelete(data, row)
    },

    // 操作删除
    handleDelete(data, row) {
      this.$confirm(row ? '确认删除用户： "' + row.realname + '" 吗？' : '确认删除所选用户吗？').then(_ => {
        userdoRemoveRole(data).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.$emit('getAgainList')
          }
        });
      }).catch(_ => { });
    }
  }
}
</script>